import React from "react";
import { Leaf, Instagram, Facebook, Twitter } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-[#2C3E2D] text-[#F9F8F6] mt-24" data-testid="app-footer">
      <div className="mx-auto max-w-7xl px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-[#F9F8F6] text-[#2C3E2D]">
              <Leaf className="h-4 w-4" strokeWidth={2} />
            </span>
            <span className="font-heading text-lg tracking-tight">Gramo<span className="text-[#E07A5F]">.</span>in</span>
          </div>
          <p className="text-sm text-[#F9F8F6]/70 leading-relaxed">
            Farm-fresh produce, curated grocery essentials and chef-crafted meals — delivered daily.
          </p>
        </div>

        <div>
          <div className="tick-label mb-4 !text-[#81B29A]">Shop</div>
          <ul className="space-y-2 text-sm text-[#F9F8F6]/80">
            <li>Fresh Fruits</li>
            <li>Vegetables</li>
            <li>Groceries</li>
            <li>Restaurant Meals</li>
          </ul>
        </div>

        <div>
          <div className="tick-label mb-4 !text-[#81B29A]">Company</div>
          <ul className="space-y-2 text-sm text-[#F9F8F6]/80">
            <li>About</li>
            <li>Farmers</li>
            <li>Delivery Areas</li>
            <li>Contact</li>
          </ul>
        </div>

        <div>
          <div className="tick-label mb-4 !text-[#81B29A]">Follow</div>
          <div className="flex gap-3">
            <a className="p-2 rounded-full border border-[#F9F8F6]/20 hover:bg-[#E07A5F] hover:border-[#E07A5F] transition-colors" href="#" aria-label="instagram"><Instagram className="h-4 w-4" /></a>
            <a className="p-2 rounded-full border border-[#F9F8F6]/20 hover:bg-[#E07A5F] hover:border-[#E07A5F] transition-colors" href="#" aria-label="facebook"><Facebook className="h-4 w-4" /></a>
            <a className="p-2 rounded-full border border-[#F9F8F6]/20 hover:bg-[#E07A5F] hover:border-[#E07A5F] transition-colors" href="#" aria-label="twitter"><Twitter className="h-4 w-4" /></a>
          </div>
        </div>
      </div>
      <div className="border-t border-[#F9F8F6]/10">
        <div className="mx-auto max-w-7xl px-6 md:px-10 py-6 flex flex-col md:flex-row justify-between items-center gap-2 text-xs text-[#F9F8F6]/60">
          <span>© {new Date().getFullYear()} Gramo Systems Pvt Ltd · www.gramo.in</span>
          <span>Made for fresh mornings & warm dinners.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
